import { Component, Injector, OnInit, ElementRef, ViewChild } from '@angular/core';
import { inject } from '@angular/core';
import { Database, ref, set, child, get, onValue, update } from "@angular/fire/database";
import { BaseComponent } from 'src/app/shared/baseComponent';
import { getAuth, signInWithPopup, GoogleAuthProvider } from "@angular/fire/auth";

const VALID_DOMAINS = ['cellpodium.com','s5-tech.com']

@Component({
  selector: 'app-lessonplans',
  templateUrl: './lessonplans.component.html',
  styleUrls: ['./lessonplans.component.css']
})
export class LessonplansComponent  extends BaseComponent implements OnInit  {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  private googleAuthProvider = new GoogleAuthProvider();

  lessonplanname = ""
  lessonplans: any = []
  lessonplansArray: any = []
  lessonplansteps: any = []
  lessonplanStep: any = {}
  selectedLessonPlan : any = "Select Lesson Plan"
  selectedLessonPlanName = ""
  showModalLessonplanStep = false
  constructor(injector: Injector) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.isAuthenticatedWithFirebase = getAuth().currentUser != null
    if (this.isAuthenticatedWithFirebase) {
      await this.onSuccessfullLogin()
    }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  async getData() {
    this.loader.show()
    const lessonplansRef = ref(this.database, 'lessonplans');
    const snapshot = await get(lessonplansRef);
    if (snapshot.exists()) {
      this.lessonplans= snapshot.val();
      this.lessonplansArray= this.collectionToArrayFB(snapshot.val());
    }
    this.loader.hide()
  }

  async signInWithGoogle() {
    const auth = getAuth();
    try {
      const credential = await signInWithPopup(auth, this.googleAuthProvider)
      if (credential.user.email == null) {
        await auth.signOut();
        return
      }
      const domain = credential.user?.email.split('@')[1]?.toLowerCase();
      if (!VALID_DOMAINS.includes(domain)) {
        await auth.signOut();
        return
      }
      this.isAuthenticatedWithFirebase = true
      await this.onSuccessfullLogin()
    } catch (error: any) {
      alert((error as Error).message)
    }
  }
  async onSelect(selectedLessonPlan: any){
    this.selectedLessonPlanName = this.lessonplansArray[selectedLessonPlan].property
    this.lessonplansteps= this.lessonplans[this.selectedLessonPlanName]
    // sort the steps by seqno
    this.lessonplansteps.sort((a: any, b: any) => a.seqno - b.seqno);
  }

  async updateLessonplanStep(){
    await set(ref(this.database, 'lessonplans'), this.lessonplans);
    this.showModalLessonplanStep = false
  }
  
  openModal(step: any){
    if (step == null) {
      this.lessonplanStep = {seqno: 0, name: "", description: "", assets:""}
      this.lessonplansteps.push(this.lessonplanStep)
    }else{
      this.lessonplanStep = step
    }

    this.showModalLessonplanStep = true
  }
  async AddLessonPlan(){
    this.loader.show()
    if (this.lessonplanname == "") {
      alert("Please enter a lesson plan name")
      return
    }
    this.lessonplans[this.lessonplanname] = [ {seqno: 0, name: "", description: "", assets:""}]
    await set(ref(this.database, 'lessonplans'), this.lessonplans);
    await this.getData()
    this.loader.hide()
  }
  async deleteLessonplanStep(lessonplanstep:any){
    let index = this.lessonplansteps.indexOf(lessonplanstep);
    this.lessonplansteps.splice(index, 1);
    await set(ref(this.database, 'lessonplans'), this.lessonplans);
  } 
  async CopyLessonPlan(){
    this.loader.show()
    if (this.selectedLessonPlanName == "") {
      alert("Please select a lesson plan to copy")
      return
    }
    if (this.lessonplanname == "") {
      alert("Please enter a lesson plan name")
      return
    }
    this.lessonplans[this.lessonplanname] = this.lessonplans[this.selectedLessonPlanName]
    await set(ref(this.database, 'lessonplans'), this.lessonplans);
    await this.getData()
    this.loader.hide()
  } 

  async DeleteLessonPlan(){
    this.loader.show()
    if (this.selectedLessonPlanName == "") {
      alert("Please select a lesson plan to delete")
      return
    }
    delete this.lessonplans[this.selectedLessonPlanName]
    set(ref(this.database, 'lessonplans'), this.lessonplans);
    this.lessonplansteps = []
    this.selectedLessonPlanName = ""
    this.getData()
    this.loader.hide()
  } 
}
